import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const customStyles = `
  /* Responsive styles for mobile devices */
  @media (max-width: 768px) {
    .congratulations-container {
      padding: 40px 16px !important;
    }

    .congratulations-card {
      width: 100% !important;
      padding: 24px 20px !important;
    }

    .congratulations-title {
      font-size: 20px !important;
    }

    .congratulations-buttons {
      width: 100% !important;
    }

    .celebration-emoji {
      font-size: 60px !important;
    }
  }

  /* Desktop styles */
  @media (min-width: 769px) {
    .congratulations-container {
      padding: 104px 88px !important;
    }

    .congratulations-card {
      width: 464px !important;
      padding: 32px 48px !important;
    }

    .congratulations-title {
      font-size: 24px !important;
    }

    .congratulations-buttons {
      width: 368px !important;
    }

    .celebration-emoji {
      font-size: 72px !important;
    }
  }

  /* Celebration animations */
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-30px);
    }
    60% {
      transform: translateY(-15px);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 40px, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes confetti-fall {
    0% {
      transform: translateY(-100px) rotate(0deg);
      opacity: 1;
    }
    100% {
      transform: translateY(100vh) rotate(720deg);
      opacity: 0;
    }
  }

  .celebration-emoji {
    animation: bounce 2s infinite;
  }

  .congratulations-card {
    animation: fadeInUp 0.8s ease-out;
  }

  .congratulations-title {
    animation: fadeInUp 1s ease-out 0.3s both;
  }

  .congratulations-subtitle {
    animation: fadeInUp 1s ease-out 0.5s both;
  }

  .congratulations-buttons {
    animation: fadeInUp 1s ease-out 0.7s both;
  }

  .confetti {
    position: fixed;
    width: 10px;
    height: 10px;
    background: #f0f;
    animation: confetti-fall 3s linear infinite;
    z-index: 1000;
  }

  .confetti:nth-child(1) { left: 10%; background: #143E9F; animation-delay: 0s; }
  .confetti:nth-child(2) { left: 20%; background: #1ed760; animation-delay: 0.5s; }
  .confetti:nth-child(3) { left: 30%; background: #ffd700; animation-delay: 1s; }
  .confetti:nth-child(4) { left: 40%; background: #ff6b6b; animation-delay: 1.5s; }
  .confetti:nth-child(5) { left: 50%; background: #4ecdc4; animation-delay: 2s; }
  .confetti:nth-child(6) { left: 60%; background: #45b7d1; animation-delay: 0.3s; }
  .confetti:nth-child(7) { left: 70%; background: #f9ca24; animation-delay: 0.8s; }
  .confetti:nth-child(8) { left: 80%; background: #f0932b; animation-delay: 1.3s; }
  .confetti:nth-child(9) { left: 90%; background: #eb4d4b; animation-delay: 1.8s; }
  .confetti:nth-child(10) { left: 15%; background: #6c5ce7; animation-delay: 0.2s; }
`;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

const Confetti = () => {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 1000 }}>
      {[...Array(10)].map((_, i) => (
        <div key={i} className="confetti" />
      ))}
    </div>
  );
};

const SignupDetailPage = ({ ...props }) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleGoToLogin = () => {
    history.push("/");
  };

  return (
    <div 
      className="congratulations-container"
      style={{
        backgroundColor: "#EEF2F7", 
        minHeight: "100vh", 
        padding: isMobile ? "40px 16px" : "104px 88px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 48,
        position: "relative"
      }}
    >
      <style>{customStyles}</style>
      
      {showConfetti && <Confetti />}
      
      <div style={{ 
        padding: 20.17, 
        overflow: 'hidden', 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        gap: 11.53, 
        display: 'flex' 
      }}>
        <div style={{ 
          width: 67.66, 
          height: 67.66, 
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="images/logo.svg" 
            style={{ 
              width: "100%",
              height: "100%",
              objectFit: "contain"
            }} 
            alt="Tigg Logo"
          />
        </div>
      </div>

      <div style={{ 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
        alignItems: 'flex-start', 
        gap: 24, 
        display: 'flex' 
      }}>
        <div 
          className="congratulations-card"
          style={{
            width: isMobile ? "100%" : 464,
            maxWidth: 550,
            paddingLeft: isMobile ? 20 : 48,
            paddingRight: isMobile ? 20 : 48,
            paddingTop: 32,
            paddingBottom: 32,
            background: 'white',
            boxShadow: '0px 28px 62px rgba(37, 78, 207, 0.03)',
            borderRadius: 16,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 20,
            display: 'flex'
          }}
        >
          <div 
            className="celebration-emoji"
            style={{
              fontSize: isMobile ? 60 : 72,
              width: 72,
              height: 72,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            🎉
          </div>
          
          <div style={{
            alignSelf: 'stretch',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: 16,
            display: 'inline-flex'
          }}>
            <div style={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
              display: 'inline-flex',
              width: '100%'
            }}>
              <div 
                className="congratulations-title"
                style={{
                  alignSelf: 'stretch',
                  textAlign: 'center',
                  color: '#343C46',
                  fontSize: isMobile ? 20 : 24,
                  fontFamily: 'Inter',
                  fontWeight: '700',
                  wordWrap: 'break-word'
                }}
              >
                Account Created Successfully!
              </div>
              <div 
                className="congratulations-subtitle"
                style={{
                  alignSelf: 'stretch',
                  textAlign: 'center',
                  color: '#969798',
                  fontSize: 14,
                  fontFamily: 'Inter',
                  fontWeight: '400',
                  wordWrap: 'break-word',
                  lineHeight: '20px'
                }}
              >
                Welcome to Tigg! Your account has been created and is ready to use.
              </div>
            </div>
          </div>

          <div 
            className="congratulations-buttons"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 8,
              display: 'flex',
              width: isMobile ? '100%' : 368
            }}
          >
            <Button
              type="primary"
              size="large"
              onClick={handleGoToLogin}
              style={{
                width: '100%',
                height: 48,
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 8,
                paddingBottom: 8,
                background: '#143E9F',
                boxShadow: '0px 8px 24px -8px rgba(20, 62, 159, 0.16)',
                borderRadius: 6,
                border: 'none',
                color: 'white',
                fontSize: 14,
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '21px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Go to Log In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupDetailPage;
